import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import Typography from 'gu-ui-kit/Typography'
import styles from 'components/Nav/nav.module.scss'

const COUNTER_KEYS = {
  audit: ['audit'],
  benchmark: ['benchmark'],
  recommendation: ['recommendation'],
  summary: ['audit', 'benchmark', 'recommendation'],
}

const CounterLink = React.forwardRef(({ as: Component = NavLink, children, counter, ...rest }, ref) => {
  const keys = COUNTER_KEYS[counter] || []
  const counters = useSelector((state) => state.notifications?.counters)
  const count = keys.reduce((sum, key) => sum + (counters?.[key] || 0), 0)
  const refProps = Component === NavLink ? { innerRef: ref } : { ref }

  return (
    <Component
      {...refProps}
      {...rest}
    >
      {children}
      {count !== 0 && (
        <Typography
          className={styles['nav__link-badge']}
          component={'span'}
          variant={'Body-10'}
        >
          {count}
        </Typography>
      )}
    </Component>
  )
})

CounterLink.displayName = 'CounterLink'

export default CounterLink

CounterLink.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  counter: PropTypes.oneOf(Object.keys(COUNTER_KEYS)).isRequired,
}
